<div class="cnb-kpis">
    <div class="kpi-scroll px-2 pt-2">
        <div
            *ngFor="let kpi of insightSummaryData?.kpis; let i = index"
            class="kpi-container"
            [class.selected]="kpi === selectedKpi"
            [style.border-bottom-color]="kpi.kpiColour"
            (click)="_onSelectClick(kpi)"
        >
            <div class="kpi-title">
                {{ kpi.kpiName }}
            </div>
            <div class="kpi-value">
                <ng-chart-arc
                    [options]="_arcOptsList[i]"
                    [data]="_arcDataList[i]"
                    [style.fill]="kpi.kpiColour"
                ></ng-chart-arc>
            </div>
        </div>
    </div>
</div>
